<div class="dialog">

  <app-header-dialog [iconName]="'people_outline'">
    Upload CSV File
  </app-header-dialog>

  <div class='container'>

    <div style='padding:20px 20px 0px 20px;'>

      <input id='selectedFile' style="display: none;" #file type="file" accept='*/pdf' (change)="readCSVFile($event)" />
      <button style='color:green;' mat-raised-button onclick="document.getElementById('selectedFile').click();">
        Usuários CSV
      </button>


      <input id='selectedFileSituacao' style="display: none;" #file type="file" accept='*/pdf'
        (change)="readCSVSituacao($event)" />
      <button style='margin-left:20px; color:green;' mat-raised-button
        onclick="document.getElementById('selectedFileSituacao').click();">
        Situação CSV
      </button>


    </div>


    <div class='tab-content'>
      <hr>
      <div style='color:red;'>Erros</div>
      <ul>
        <li *ngFor="let err of errors; let j = index" style='padding:5px;'>
          {{j+1}} - {{err}}
        </li>
      </ul>

      <hr>
      <div style='color:rgb(4, 87, 180);'>Válidos</div>
      <ul>
        <li *ngFor="let member of members; let i = index" style='padding:5px;'>
          {{i+1}} - {{member.name}} - {{ member.cpf }}
        </li>
      </ul>

      <ul>
        <li *ngFor="let situation of situations; let i = index" style='padding:5px;'>
          {{situation.name}} - {{ situation.cpf }} - {{ situation.situation}}
        </li>
      </ul>

      <ul>
        <li *ngFor="let cieloCode of cieloCodes; let i = index" style='padding:5px;'>
          {{cieloCode.code}} - {{ cieloCode.message }}
        </li>
      </ul>


    </div>


    <div class="action-tab" fxLayoutAlign="end" flex justify-content='flex-end'>

      <button mat-raised-button (click)='uploadCSVFile()'>
        *<mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

    </div>

  </div>
</div>